
import React from 'react'

const SignatureBlueLine = ({contactInfo, disclaimer, logo, sharedStyles}) => {

    const styles = sharedStyles;

    const localStyles = {
        blueLine: {
            padding: "0 0 0 15px",
            borderLeft: "3px solid #013C65"
        },
        photo : {
            boxSizing: 'border-box',
            borderStyle: 'none',
            width: '78px'
        }
    }

    return(
        <div className="signatureBlock" id="blueLine">
            <table border="0" cellPadding="0" cellSpacing="0">
                <tbody>
                    <tr>
                        <td>
                            <table border="0" cellPadding="0" cellSpacing="0">
                                <tbody><tr>
                                    <td style={localStyles.blueLine}>
                                        <table border="0" cellPadding="0" cellSpacing="0" width="300">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <div className="name">
                                                            <p style={sharedStyles.headingStyle}><strong>
                                                                {contactInfo.name}
                                                                </strong></p>
                                                            { contactInfo.pronouns && 
                                                                <p style={sharedStyles.pStyle}>Pronouns: {contactInfo.pronouns}</p>
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td height="12" style={sharedStyles.height12}></td> 
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="title-department">
                                                            <p style={sharedStyles.pStyle}>
                                                                    { contactInfo.title &&
                                                                        <>{contactInfo.title}</>
                                                                    }
                                                                    { contactInfo.title && contactInfo.department &&
                                                                    <br />
                                                                    }
                                                                    { contactInfo.department &&
                                                                        <>{contactInfo.department}</>
                                                                    }            
                                                                    </p>  
                                                        </div>
                                                    </td>
                                                </tr>
                                                
                                                <tr>
                                                    <td height="12" style={sharedStyles.height12}></td> 
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="title-department">
                                                            <p style={sharedStyles.pStyle}><strong>University of Northern Colorado</strong><br />
                                                                { contactInfo.building &&
                                                                    <>{contactInfo.building}<br /></>
                                                                }
                                                                {contactInfo.address &&
                                                                <>{contactInfo.address},</> 
                                                                }
                                                                {contactInfo.campusbox &&
                                                                    <> Campus Box {contactInfo.campusbox}</>
                                                                }                                                                    
                                                                {contactInfo.city &&
                                                                <><br />
                                                                {contactInfo.city}</>
                                                                }
                                                            </p>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td height="12" style={sharedStyles.height12}></td> 
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="contact-info">
                                                            <p style={sharedStyles.pStyle}>
                                                            
                                                            {!!(contactInfo.phoneoffice) &&
                                                                <span className="no-break" style={sharedStyles.inlineBlock}>
                                                                    O: <a href={"tel:" + contactInfo.phoneoffice} style={sharedStyles.url}>{contactInfo.phoneoffice}</a>
                                                                </span> 
                                                            }
                                                            
                                                            {!!(contactInfo.phonecell) &&
                                                                <span className="no-break" style={sharedStyles.inlineBlock}>
                                                                    &nbsp;| C: <a href={"tel:" + contactInfo.phonecell} style={sharedStyles.url}>{contactInfo.phonecell} </a>
                                                                </span> 
                                                            }

                                                            {!!(contactInfo.phonefax) &&
                                                                <span className="no-break" style={sharedStyles.inlineBlock}>
                                                                    &nbsp;| F: {contactInfo.phonefax}
                                                                </span>
                                                            }
                                                            </p>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td height="12" style={sharedStyles.height12}></td> 
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="contact-info">
                                                            <p style={sharedStyles.pStyle}><a href={contactInfo.url} style={sharedStyles.url}>{contactInfo.url}</a></p>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td height="12" style={sharedStyles.height12}></td> 
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody></table>
                        </td>
                    </tr>
                    {!!(disclaimer) &&
                        <tr>
                            <td>
                                <table border="0" cellPadding="0" cellSpacing="0">
                                    <tbody>
                                        <tr>
                                            <td height="24" style={sharedStyles.height24}></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2">
                                                <p className="disclaimer" style={sharedStyles.disclaimer}>
                                                    {disclaimer}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td height="24" style={sharedStyles.height24}></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    }

                </tbody>
            </table>
        </div>
    )
}

export default SignatureBlueLine;